'use strict';

exports.LendingPeriod = {
    period:7,
    holter_oneday_period:10,
    holter_fiveday_period:10,
    holter_sevenday_period:12,
    holter_tenday_period:15,
    holter_fourteen_period:19
}

// 権限へ、外部ユーザーを追加する場合「externalUsers」にも記載をお願いします。
exports.role = {
    role_admin : 1,
    role_headOffice : 2,
    role_headOffice_sales : 3,
    role_headOffice_division : 4,
    role_headOffice_sw : 5,
    role_salesOffice : 6,
    role_psc : 7,
    role_kawagoe: 8,
    role_hospital: 9,
    role_corporation: 10,
    role_dealer: 11,
    role_dealer_facility: 12,
    role_judgment: 13,
    role_analysis: 14,
    role_accommodations:15,
    role_holter_judgment: 16,
    role_kawagoe_cpap: 17,
    role_call_center: 18,
    role_headOffice_call: 19,
    role_ndss: 20,
}
var externalUsersRoleList = [
    this.role.role_hospital,
    this.role.role_corporation,
    this.role.role_dealer,
    this.role.role_dealer_facility,
    this.role.role_judgment,
    this.role.role_analysis,
    this.role.role_accommodations,
    this.role.role_holter_judgment,
]
exports.isExternalUser = function(roleId) {
    return externalUsersRoleList.find((element) => element == roleId) ? true : false;
}
exports.isInternalUser = function(roleId) {
    return externalUsersRoleList.find((element) => element == roleId) ? false : true;
}

exports.choicesType ={
    hstKind : "1",
    psgMethod: "2",
    psgReportFormat: "3",
    sleepwareG3Ver: "4",
    kenshinKind: "5",
    kenshinDevice: "6",
    deliveryTime: "7",
    cannulaSize: "8",
    beltSize: "9",
    attachedWaveform: "10",
    inspectionPurpose: "11",
    turnOnOff: "12",
    machineStatus: "13",
    holterKind: "14",
    holterMethod: "15",
    holterAnalysisOp: "16",
    holterInspectionPeriod: "17",
    holterInspectionPurpose: "18",
    cpapKind: "101",
    holterHstKind: "19",
    holterKindSp: "20",
    pDashboardTermKind: "22",
    pDashboardLatestKind: "23",
    pDashboardLatestDays: "24",
    pDashboardStringFilter: "25",
    pDashboardNumberFilter: "26",
    pDashboardTextDataType: "27",
    pDashboardTextFormat: "28",
    pDashboardPdfReportType: "29",
    WP300SnoreSensor: "30",
    WP300SnoreSensorHolter: "31",
    pDashboardAverageUsageMinutesType: "32",
    holterInspectionPeriodJudgment : "34",
}
// HST機種Value
exports.hstModelValue = {
   SP : "1",
   PMP300E: "2",
   WP: "3",
   WP300: "7",
   SIMONJ: "8",
   NIGHTGRAF: "9"
}
// 簡易検査のvalue
exports.psgAnalysisValue = {
    SW: "106",           // 簡易検査スマートウォッチ
    SW_RENTAL: "107",    // 簡易検査スマートウォッチ(レンタル込み)
    ALICE: "108",        // 簡易検査 Aliceシリーズ
    ALICE_RENTAL: "109", // 簡易検査 Aliceシリーズ(レンタル込み)
    WP: "110"            // 簡易解析 ウォッチパット
}
exports.consentStatement = {
    registPage : 1,
    hst_hospital: 2,
    hts_dealer: 3,
    psg_hospital: 4,
    psg_dealer: 5,
    kenshin_corp: 6,
    kenshin_dealer: 7,
    kenshin_hospital: 8,
    kenshin_accommodations: 9,
    care_orchestrator:10,
    holter_hospital: 11,
    holter_dealer: 12,
    holter_analysis_hospital: 13,
    holter_analysis_dealer: 14,
    cpap: 15,
}
exports.service = {
  hst:              0b000000001,
  psg:              0b000000010,
  kenshin:          0b000000100,
  holter:           0b000001000,
  holter_analysis:  0b000010000,
  cpap:             0b000100000,
  care_orchestrator:0b001000000,
  inspection_report:0b010000000,
}
exports.requestComponent = {
  hst:"HSTRequest",
  psg:"PSGRequest",
  cpap:"CpapRequest",
  holter:"HolterRequest",
}
exports.UploadType = {
    hst_report : 1,
    psg_data : 2,
    psg_report : 3,
    kenshin_report : 4,
    deliveryslip: 5,
    holter_data: 6,
    h_analysis_data: 7,
    holter_report: 8,
    holter_patient_report: 9,
    holter_judgment_report: 10,
}
exports.extUserStatus = {
    tempReg: "1",
    brunchReview: "2",
    registed: "3",
    addRequest: "4",
    dummy: "0",
}
exports.extUserStatusStr = {
    tempReg: "仮登録",
    brunchReview: "支店回送中",
    registed: "本登録",
    addRequest: "追加依頼中",
    dummy: "暫定",
}
// ケア　オーケストレーター申請種別
exports.coOrderType = {
    facilityAdd: "1",
    facilityUpdate: "2",
    userAdd: "3",
    userUpdate: "4",
    userDel: "5",
}
// ケア　オーケストレーター申請種別
exports.coOrderTypeStr = {
    facilityAdd: "施設登録",
    facilityUpdate: "施設変更",
    userAdd: "ユーザー追加",
    userUpdate: "ユーザー変更",
    userDel: "ユーザー削除",
}
// ケア　オーケストレーター申請状態
exports.coStatus = {
    requestPending: "1",
    requestConfirmed: "5",
    requestCertification: "6",
    added: "2",
    cancel: "3",
}
// ケア　オーケストレーター申請状態
exports.coStatusStr = {
    requestPending: "申込中 (保留中)",
    requestConfirmed: "申込中 (確認済)",
    requestCertification: "証明書手続き中",
    added: "登録済",
    cancel: "キャンセル",
}
exports.requestStatus = {
    inspectionRequest: 1,       //検査依頼中    依頼中
    deviceReady: 2,             //機器準備中    検査中
    shippingReady: 3,           //出荷準備中    検査中              未出荷
    inspenction: 4,             //検査中        検査中              出荷済み
    deviceReturn: 5,            //機器受領中    検査中
    analysisForwarding: 6,      //解析依頼中    検査中
    analysisRequest: 7,         //解析依頼中    依頼中
    analysis: 8,                //解析中        解析中
    resultComfirm: 9,           //結果確認中    解析中
    resultSendReady: 10,        //結果送付待    解析中
    kawagoeAcceptance: 11,      //川越受付中    検査中
    jugdmentRequest: 12,        //判定依頼中    判定中
    completion: 13,             //完了（未計上） 完了
    salesAppropriation: 14,     //売上計上中     完了
    completionAppropriation: 15,//完了（計上済） 完了
    reInspection: 16,           //再検査調整中   再検査調整中
    cancel: 17,                 //キャンセル     キャンセル         キャンセル
    completionNotAppropriation: 18,//完了（未計上） 完了
    approving: 20,              //検査依頼中     承認申請中
    deposit_regist: 21,         //院内貸出依頼中     院内貸出依頼中
    depositMachine: 22,         //院内貸出中         院内貸出中
    depositMachineRental: 23,   //院内機患者貸出中   検査中
    depositMachineReturnWait: 24,　//院内貸出解除       院内機回収中
    depositMachineRelease: 25,  //院内貸出解除       院内貸出解除
    replaceFile: 100,            //ファイル差し替え依頼
    approvalRejecte: 101,        //承認却下
    replaceFileFinish: 102,      //ファイル差し替え実施
    replaceReportFile: 103,          //完了後解析ファイル差替
    replaceReportFileapproval: 104,  //完了後差替ファイル承認
    dataExtracted:105, // 判定無し企業検診のデータ抽出済み
    holterJudgmentRequest: 110, //ホルター判定依頼中
    holterJudgmentReady: 111 //ホルター判定中
}
exports.machineStatus = {
    available: 1,         //利用可能
    deviceReady: 2,       //出荷予約中
    shipping: 3,          //貸出中
    cleaning: 4,          //クリーニング中
    overdue: 5,           //延滞中
    tempIntroduction: 6,  //仮導入
    underRepair: 7,       //修理中
    scheduledReturned: 8, //返却予定
    leaseUp: 9,           //リースアップ
    delete: 10,           //削除
    depositDeviceReady: 11,   //院内貸出機出荷予約中
    depositShipping: 12,      //院内機貸出中
    depositScheduledReturned: 13,      //院内貸出機返却予定
}
exports.cpapRequestStatus = {
    request: 1,              //指示書申請中      仮受付
    Approving: 2,            //指示書承認中      仮受付
    scheduledreturn: 3,      //機器返却予定      受付済み
    approved: 4,             //指示書承認済み    仮受付
    preparingEquipment: 5,   //機器準備中        受付済み
    internalProcessing: 16,  //内部処理中        受付済み
    preparingShip: 6,        //出荷準備中        受付済み
    shipped: 7,              //出荷完了          受付済み
    deviceReturn: 8,         //機器返却予定      受付済み
    changeCompleted: 9,      //変更完了          受付済み
    equipmentReceipt: 10,    //機器受領          受付済み
    tempTakenOut: 11,        //仮持出済み        受付済み
    transferUndecided: 12,   //転院先未定     受付済み
    kanjadoutaiRequest: 13,  //患者動態登録依頼中 受付済み
    completion: 14,          //完了              完了
    cancel: 15,              //キャンセル        キャンセル
    returnWait: 100,         //返却待ち
    untreatedMachineReturned: 200, //未処理機返却済
    regularExchangeReturned: 201 //定期交換返却済
}
exports.cpapManagementStatus = {
    prescription: 1   //処方中
    , cancel: 2       //処方中止
    , transferring: 3 //転院中
    , undecided: 4    //転院先未定
    , coming: 5       //転入予定
}
exports.cpapPatientRegisterStatus = {
    unrequested: 0         //未依頼
    , registRequestWait: 1 //登録依頼中
    , registRequest: 2     //登録待ち
    , Registered: 3        //登録済み
    , updateWait: 4      //更新待ち
    , updateRequest: 5   //更新依頼中
}
exports.reportFormat = {
    pdf: "1",
    pdf_patient: "2",
    simplifiedReport: "3",
    simplified_append_wave: "4",
    sleepProfiler: "5",
    simplified_append_increaseOrDecrease: "6",
    holterAnalysisReport: "7",
    simplified_nppv: "9",
    nightGraf: "11",
    simonJ:"12"
}
exports.analysisMethod = {
    standardManual: "101",
    expertReview: "103",
    sleepProfiler: "105",
    simplified_smartWatch: "106",
    simplified_alice: "108",
    simplified_watchPad: "110",
}
exports.analysisOption = {
    included: "1",     //オプションなし
    includedAll: "2",  //専門医師による判定
}
exports.holterAnalysisMethod = {
    one: "401",     //ホルター心電図解析（1日）
    three: "402",  //ホルター心電図解析（3-14日）
}
exports.registPage = {
    Loading: 1,   
    QueryError: 2, 
    Login: 3,
    InputUserInfo: 4,
    ComfirmCORegist: 5,
    CoAgreement: 6,
    InputCOclinicInfo: 7,
    InputCOuserInfo: 8,
    ComfirmCOInfo: 9,
    FinishRegist: 999
}
exports.cpapShippingMethodList = [
    //{ code: 0, name: "代引き" }
    { code: 1, name: "発送" }
    ,{ code: 2, name: "持参" }
]
exports.cpapSearchKindGroup= [
    { code: 1, name: "新規処方申込み", progress:1}
    , { code: 2, name: "処方変更申込み", progress: 1 }
    , { code: 3, name: "処方中止申込み", progress: 2}
    , { code: 4, name: "転院申込み", progress: 3}
    , { code: 5, name: "処方再開申込み（中止再開）", progress: 1}
    , { code: 6, name: "処方再開申込み（転入）", progress: 1}
    , { code: 10, name: "機器シリアル更新", progress: 1 }
    , { code: 20, name: "未処理機返却済", progress: 1}  
]
exports.cpapKindMap = {
    application: 1,               //新規処方申込み
    applicationChange: 2,         //処方変更申込み
    applicationCancel: 3,         //処方中止申込み
    applicationChangeHospital: 4, //転院申込み
    applicationResume: 5,         //処方再開(転院患者)申込み
    applicationDepositMachine: 6, //預託機申込み
    applicationTempRemoval: 7,    //仮持出申込み
    applicationEquipmentReturn: 8, //機器返却申込み
    applicationPhilipsCorrespondence: 10, //機器シリアル更新
    applicationUntreatedMachineReturned: 20, //未処理機返却済
}
exports.cpapSenderMaster = [
    { code: 0, name: "川越" }
    , { code: 1, name: "支店" }
]
//ケアオケ利用状況(検索値)
exports.coUse = {
 notUse: 1, //未利用
 waitting: 2,//申請待ち
 inUse: 3,  //利用中
 registed: 4, //登録待ち  
}
//ケアオケ利用状況(DB登録値)
exports.coUse_db = {
 notUse: 1,  //「はじめて利用する」
 inUse: 2,   //「既に利用中」
 afterUse: 3, //「今は利用しない」
}

// TODO: OK:ローンチ時のフラグ true=隠す状態 , false=隠さない_23_0220_Doki
exports.atLaunchHidden = {
    hiddenFlag: true,
}

// コール種別
exports.cpapCallTypeList = [
    { code: 1, name: "発送前コール" },
    { code: 2, name: "到着後コール" },
    { code: 3, name: "フォローアップコール(初回)" },
    { code: 4, name: "フォローアップコール(2回目)" },
    { code: 30, name: "返却依頼" },
    // 未返却は返却依頼に変更。ただし、後日復活する可能性があるのでここではコメントアウトのみしておく
    // { code: 10, name: "未返却" },
    { code: 20, name: "中止指示未" },
    { code: 41, name: "CPAP機器未返却催促" },
    { code: 42, name: "検査機器未返却催促" },
    { code: 90, name: "支店連絡" }
]
// CPAPコールステータス
exports.cpapCallStatusList = [
    { code: 1, name: "未架電" }
    , { code: 2, name: "架電未完了" }
    , { code: 3, name: "完了" }
]
// CPAPエスカレーションステータス
exports.cpapCallEscalationStatusList = [
    { code: 1, name: "新規" }
    , { code: 2, name: "未対応" }
    , { code: 3, name: "対応中" }
    , { code: 4, name: "対応済み" }
]
// エスカレーション種別
exports.escalationTypeList = [
    { code: 1, name: "支店対応あり" },
    { code: 2, name: "登録情報の変更あり" },
    { code: 3, name: "商品手配あり" },
    { code: 9, name: "対応不要（報告のみ）"}
],

// CPAP直送先種別
exports.cpapDirectShippingList = [
    { code: 0, name: "直送不可" }
    , { code: 1, name: "患者宅" }
    , { code: 2, name: "クリニック" }
    , { code: 3, name: "ディーラー配送" }
]
// CPAPリースアップ種別
exports.cpapLeaseUpList = [
    { code: 0, name: "不可" }
    , { code: 1, name: "その他" }
    , { code: 2, name: "中止" }
    , { code: 3, name: "医療機関対応" }
    , { code: 4, name: "営業所対応" }
    , { code: 5, name: "業者対応" }
    , { code: 6, name: "EncorePro2インストールトラブル" }
    , { code: 7, name: "医師・医療機関未承諾" }
    , { code: 8, name: "加温加湿器" }
    , { code: 9, name: "クリニック配送" }
    , { code: 10, name: "ディーラー配送" }
    , { code: 11, name: "患者" }
]
// 次案件繋ぎ込み
exports.introductionTemplate = 
`平素より大変お世話になりまして誠にありがとうございます。

この度、当院で検査を実施した患者様について、さらなる検査の必要があると思われたため、貴院を勧めさせていただきました。

お忙しいところ恐れ入りますが、よろしくご高診下さいますようお願い申し上げます。`

// 次案件繋ぎ込み
exports.introductionTemplate = {
'hst': 
`平素より大変お世話になっております。
    
この度、当院/当診療科で検査を実施した患者様について、
さらなる検査の必要があると思われるため、貴院/貴診療科を紹介させていただきました。

お忙しいところ恐れ入りますが、ご高診くださいますようよろしくお願い申しあげます。`,
    
'psg':
`平素より大変お世話になっております。
    
この度、当院/当診療科で検査を実施した患者様について、
さらなる検査の必要があると思われるため、貴院/貴診療科を紹介させていただきました。

お忙しいところ恐れ入りますが、ご高診くださいますようよろしくお願い申しあげます。`,

'cpap':
`平素より大変お世話になっております。

この度、当院/当診療科で検査を実施した患者様について、
CPAP治療の必要があると思われるため、貴院/貴診療科を紹介させていただきました。

お忙しいところ恐れ入りますが、ご高診、ご加療くださいますようよろしくお願い申しあげます。`,
    
'holter':
`平素より大変お世話になっております。
    
この度、当院/当診療科で検査を実施した患者様について、
さらなる検査の必要があると思われるため、貴院/貴診療科を紹介させていただきました。

お忙しいところ恐れ入りますが、ご高診くださいますようよろしくお願い申しあげます。`,
}

//20230113追加
exports.cpapPrescription = {
    changeSupplies: 1,         //変更有（用品）    変更有（用品）
    changeSetValue: 2,         //変更有（設定値）  変更有（設定値）
}

// 半角数字のみ入力
exports.invalidNumberMessage = "半角数字で入力してください";
exports.postcodePlaceholder = "ハイフン(-)なし。半角数字のみ。7桁。";
exports.phonePlaceholder = "ハイフン(-)なし。半角数字のみ";
exports.digitErrorZipMessage = "郵便番号は7桁で入力してください";

// 再検査実施時 確認ダイアログ用
exports.reExaminationConfirmTemplate = {
    cancelText: "キャンセル",
    confirmText: "OK",
    message: `被験者様へ再検査のご連絡をお願い致します。<br>
              再検査の依頼は下記のOKボタンを押してください。<br>
              <br>
              発送に関しましては、ご依頼日の最短出荷日にて手配致します。<br>
              <span class="text-red">※機種の在庫状況により出荷日が遅延する場合もございます。</span><br>
              前回検査依頼時に時間指定を選択されている場合は同時間帯で発送となります。
            `,
};

// 預託院内在庫関連_202310_P2
exports.escrowContent = {
    itemName: "",
    imgSrc: "",
    quantity: "",
    itemCode: "",
    quotationNumber: "",
    quotationDetailsNumber: "",
    deliveryPrice: "",
    latestOrderRegisteredDate: "",
    serial: "",
};
exports.escrowDeviceSelectList = [
    { text: "", value: "" },
    {
        text: "ドリームステーション Auto",
        value: "ドリームステーション Auto",
    },
    {
        text: "ドリームステーション BiPAP Auto",
        value: "ドリームステーション BiPAP Auto",
    },
    { text: "ドリームステーション Go", value: "ドリームステーション Go" },
    { text: "ドリームステーション Pro", value: "ドリームステーション Pro" },
    { text: "DSモデム", value: "DSモデム" },
    { text: "DS加湿器", value: "DS加湿器" },
    { text: "S.box", value: "S.box" },
    { text: "S.box加湿器", value: "S.box加湿器" },
    { text: "Prisma", value: "Prisma" },
    { text: "Prisma加湿器", value: "Prisma加湿器" },
];
exports.escrowMaskSelectList = [
    { text: "", value: "" },
    { text: "ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ", value: "ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ" },
    { text: "ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ", value: "ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ" },
    { text: "ﾄﾞﾘｰﾑｳｪｱﾈｰｻﾞﾙﾏｽｸ", value: "ﾄﾞﾘｰﾑｳｪｱﾈｰｻﾞﾙﾏｽｸ" },
    { text: "ｺﾝﾌｫｰﾄｼﾞｪﾙﾌﾞﾙｰ", value: "ｺﾝﾌｫｰﾄｼﾞｪﾙﾌﾞﾙｰ" },
    { text: "ﾄﾞﾘｰﾑｳｪｱ ｼﾘｺﾝﾋﾟﾛｰﾏｽｸ", value: "ﾄﾞﾘｰﾑｳｪｱ ｼﾘｺﾝﾋﾟﾛｰﾏｽｸ" },
    { text: "ﾄﾞﾘｰﾑｳｪｱﾌﾙ", value: "ﾄﾞﾘｰﾑｳｪｱﾌﾙ" },
    { text: "ｱﾏﾗﾋﾞｭｰﾌﾙﾌｪｲｽﾏｽｸ", value: "ｱﾏﾗﾋﾞｭｰﾌﾙﾌｪｲｽﾏｽｸ" },
    { text: "ｱﾏﾗﾌﾙﾌｪｲｽﾏｽｸ", value: "ｱﾏﾗﾌﾙﾌｪｲｽﾏｽｸ" },
    { text: "ｱﾏﾗｼﾞｪﾙﾌﾙﾌｪｲｽﾏｽｸ", value: "ｱﾏﾗｼﾞｪﾙﾌﾙﾌｪｲｽﾏｽｸ" },
    { text: "ｳｨｽﾌﾟ小児用ﾈｰｻﾞﾙﾏｽｸ", value: "ｳｨｽﾌﾟ小児用ﾈｰｻﾞﾙﾏｽｸ" },
    { text: "ﾌｨｯﾄﾗｲﾌ", value: "ﾌｨｯﾄﾗｲﾌ" },
];
exports.escrowOptionItemSelectList = [
    { text: "", value: "" },
    { text: "花粉フィルタ", value: "花粉フィルタ" },
    { text: "回路", value: "回路" },
    { text: "チャンバー", value: "チャンバー" },
    { text: "SDカード(10枚入り)", value: "SDカード(10枚入り)" },
    { text: "microSD", value: "microSD" },
];
exports.escrowBundleItemSelectList = [
    { text: "", value: "" },
    { text: "QSASガイド", value: "QSASガイド" },
    { text: "Q&A", value: "Q&A" },
];
exports.quantitySelectList = [
    { text: "", quantity: "" },
    { text: "1", quantity: 1 },
    { text: "2", quantity: 2 },
    { text: "3", quantity: 3 },
    { text: "4", quantity: 4 },
    { text: "5", quantity: 5 },
    { text: "6", quantity: 6 },
    { text: "7", quantity: 7 },
    { text: "8", quantity: 8 },
    { text: "9", quantity: 9 },
    { text: "10", quantity: 10 },
];
exports.picoNesalMaskList = [
    { text: "", value: "" },
    { text: "piko1", value: 1 },
    { text: "piko2", value: 2 },
    { text: "piko3", value: 3 },
    { text: "piko4", value: 4 },
    { text: "piko5", value: 5 },
    { text: "piko6", value: 6 },
    { text: "piko7", value: 7 },
    { text: "piko8", value: 8 },
    { text: "piko9", value: 9 },
    { text: "piko10", value: 10 },
];
exports.wispNesalMaskList = [
    { text: "", value: "" },
    { text: "wisp1", value: 1 },
    { text: "wisp2", value: 2 },
    { text: "wisp3", value: 3 },
    { text: "wisp4", value: 4 },
    { text: "wisp5", value: 5 },
    { text: "wisp6", value: 6 },
    { text: "wisp7", value: 7 },
    { text: "wisp8", value: 8 },
    { text: "wisp9", value: 9 },
    { text: "wisp10", value: 10 },
];
exports.escrowItemCodeList = [
    // フィリップスより院内在庫注文できる全てのリストをいただく予定となっていたが貰えていないので下記は仮のマスタ（2023-10-12丸山）
    {itemCode:"RJPX500S16", itemName: "ドリームステーション Auto"},
    {itemCode:"RJPX700S16", itemName: "ドリームステーション BiPAP Auto"},
    {itemCode:"RJPG500S16", itemName: "ドリームステーション Go"},
];
exports.prescriptionHardwareList = [
    {
    "itemCode": 'RJPX500S16',
    "itemName": 'ドリームステーションAuto',
    "reportFormatType": 1,
    }, {
    "itemCode": 'RJPX500S16F',
    "itemName": 'ドリームステーションAuto_Fﾚﾝﾀﾙ',
    "reportFormatType": 1,
    "standardItemCode": 'RJPX500S16(F)',
    }, {
    "itemCode": 'RJPX501S16',
    "itemName": 'ドリームステーションAuto_12㎜ ﾚﾝﾀﾙ',
    "standardItemCode": 'RJPX500S16(F)',
    "reportFormatType": 1,
    }, {
    "itemCode": 'RJPX400S16',
    "itemName": 'ドリームステーションPro',
    "reportFormatType": 2,
    "standardItemCode": 'RJPX400S16',
    }, {
    "itemCode": 'RJPG500S16',
    "itemName": 'ドリームステーションGo',
    "reportFormatType": 3,
    "standardItemCode": 'RJPG500S16',
    }, {
    "itemCode": 'RJPX700S16',
    "itemName": 'ドリームステーションBiPAP Auto',
    "reportFormatType": 4,
    "standardItemCode": "RJPX700S16(F)",
    }, {
    "itemCode": 'RJPX700S16F',
    "itemName": 'ドリームステーションBiPAP Auto_Fﾚﾝﾀﾙ',
    "reportFormatType": 4,
    "standardItemCode": "RJPX700S16(F)",
    }, {
    "itemCode": 'R1152708',
    "itemName": 'エスボックスバイスタルク',
    "reportFormatType": 5,
    "standardItemCode": 'R1152708(R1151127)',
    }, {
    "itemCode": 'R1151127',
    "itemName": 'エスボックスバイスタルク',
    "reportFormatType": 5,
    "standardItemCode": 'R1152708(R1151127)',
    }, {
    "itemCode": 'R1151882',
    "itemName": 'プリズマライン(prisma25S)',
    "reportFormatType": 6,
    "standardItemCode": 'R1151882',
    },
];
// 巻き取りステータス
exports.takeupStatus = {
    nonTarget:0,    // 対象無し
    mainOffice:1,   // 本社
    branch:2        // 支店
}
// CPAP選択肢マスタ(M_CPAP_CHOICES)取得用コード
exports.cpapChoicesType ={
    customerCategory: "021",    //得意先区分
    orderProcessType: "022",    //処理タイプ(オーダー)
    returnProcessType: "023",   //処理タイプ(返却)
    rentalType: "028",          //レンタル種別
    usage: "030",               //用途
    cancellReason: "031",       //契約取消理由
    billedCurrentMonth: "032",  //当月請求
    returnPurpose: "033",       //返却用途
    paymentPurpose: "041",      //支給用途
    deliveryTimeZone: "059",    //配達時間帯
    strategicMeasures: "067",   //戦略施策
    reserve: "068",             //予備
    bringOutdisplayFlag: "069", //持出入力表示/非表示フラグ
    departmentCode: "099"       //診療科コード
}
// 患者ダッシュボードのサービス名
exports.pDashboardServiceName = "CPAP患者レポート";
/** 患者ダッシュボード利用状況(検索値) */
exports.pDashboardUse = {
    /** 未利用 */
    notUse: 1,
    /** 連携待ち */
    coConnecting: 2,
    /** 確認待ち */
    lastConfirming: 3,
    /** 利用中 */
    inUse: 4,
}
/** 患者ダッシュボードメイン画面の対象期間の種類 */
exports.pDashboardTermKind = {
    /** 前回出力日から */
    lastOutputDate: "0",
    /** 直近 */
    latest: "1",
    /** 期間指定 */
    term: "2",
    /** すべての期間 */
    all: "3"
}
/** 患者ダッシュボードメイン画面のフィルタ条件 */
exports.pDashboardFilterCondition = {
    /** 含む */
    include: "0",
    /** 等しい */
    equal: "1",
    /** 以上 */
    greaterEqual: "2",
    /** 以下 */
    lessEqual: "3",
    /** より大きい */
    greater: "4",
    /** より小さい */
    less: "5"
}
/** 患者ダッシュボードファイル出力設定画面のフォーマット種別 */
exports.pDashboardFormatKind = {
    /** テキスト */
    text: "0",
    /** PDF */
    pdf: "1",
    /** オリジナル */
    original: "2"
}


// WEBPACK FOOTER //
// ./src/components/mock/base/const.js